import {Presenter} from './Presenter'

export const Edit = () => {
  return <Presenter />
}
